import { z } from 'zod';
import { HstTreatmentSchema } from '../rate/enums.schema.js';
import { InvoiceLineTypeSchema } from './enums.schema.js';
export const InvoiceLineResponseSchema = z.object({
    id: z.string().uuid(),
    invoiceId: z.string().uuid(),
    shiftId: z.string().uuid().nullable(),
    lineType: InvoiceLineTypeSchema,
    description: z.string(),
    quantityHours: z.string(), // Decimal as string for JSON safety
    unitBillRate: z.string(),
    subtotalCents: z.number().int().min(0),
    hstTreatment: HstTreatmentSchema,
    hstCents: z.number().int().min(0),
    totalCents: z.number().int().min(0),
    appliedPolicyId: z.string().uuid().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=invoice-line.schema.js.map